import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const { string, arrayOf, bool, node, oneOfType } = proptypes;

export const List = ({ list, isBold = false }) => {
  return (
    <ul className={`sui-list-disc sui-pl-6${isBold ? ' sui-font-bold' : ''}`}>
      {list.map((listItem, listIndex) => {
        const key = typeof listItem === 'string' ? listItem : `list-${listIndex}`;
        return (
          <li key={key}>
            <Typography variant="body-base" weight={isBold ? 'bold' : 'regular'} height="normal">
              {listItem}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
};

List.propTypes = {
  list: arrayOf(oneOfType([string, node])).isRequired,
  isBold: bool
};
